import Paper from '@zenbusiness/zui/Paper';
import { styled } from '@zenbusiness/zui/styles';

export const PaperStyle = ({ theme, disabled }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  boxShadow: 'none',
  borderRadius: '12px',
  border: `1px solid ${theme.palette.border.main}`,
  '&:hover': {
    border: !disabled && `1px solid ${theme.palette.fixed.black}`
  },
  '&:active': {
    border: !disabled && `1px solid ${theme.palette.fixed.black}`
  },
  '&:focus': {
    border: !disabled && `1px solid ${theme.palette.fixed.black}`
  },

  '& .MuiInputBase-root .MuiInputBase-input': {
    ...theme.typography.md,
    [theme.breakpoints.down('sm')]: {
      '@supports (-webkit-touch-callout: none)': {
        transform: 'scale(0.875)', // scale down by 14/16 = 87.5%
        fontSize: '16px',
        lineHeight: '24px',
        transformOrigin: 'left'
      }
    }
  }
});

export const PaperStyled = styled(Paper)(PaperStyle);
